export function isDateInThisWeek(dateString: string): boolean {
	const today = new Date();
	const dayOfWeek = today.getUTCDay(); // Usar getUTCDay() para obtener la hora UTC
	const differenceToMonday = (dayOfWeek === 0 ? 6 : dayOfWeek - 1);
	const firstDayOfWeek = new Date(Date.UTC(today.getUTCFullYear(),
		today.getUTCMonth(), today.getUTCDate() - differenceToMonday));
	firstDayOfWeek.setUTCHours(0, 0, 0, 0);
	const lastDayOfWeek = new Date(firstDayOfWeek);
	lastDayOfWeek.setUTCDate(firstDayOfWeek.getUTCDate() + 6);
	lastDayOfWeek.setUTCHours(23, 59, 59, 999);
	const dateToCheck = CreateDateFromNoticeDate(dateString)
	return dateToCheck >= firstDayOfWeek && dateToCheck <= lastDayOfWeek && !AreTwoDatesTheSameDay(dateToCheck, today);
}

export function isDateInThisWeekWithDate(dateToCheck: Date): boolean {
	const today = new Date();
	const dayOfWeek = today.getUTCDay(); // Usar getUTCDay() para obtener la hora UTC
	const differenceToMonday = (dayOfWeek === 0 ? 6 : dayOfWeek - 1);
	const firstDayOfWeek = new Date(Date.UTC(today.getUTCFullYear(),
		today.getUTCMonth(), today.getUTCDate() - differenceToMonday));
	firstDayOfWeek.setUTCHours(0, 0, 0, 0);
	const lastDayOfWeek = new Date(firstDayOfWeek);
	lastDayOfWeek.setUTCDate(firstDayOfWeek.getUTCDate() + 6);
	lastDayOfWeek.setUTCHours(23, 59, 59, 999);
	return dateToCheck >= firstDayOfWeek && dateToCheck <= lastDayOfWeek && !AreTwoDatesTheSameDay(dateToCheck, today);
}

export function AreTwoDatesTheSameDay(date1: Date, date2: Date): boolean {
	return (
		date1.getFullYear() === date2.getFullYear() &&
		date1.getMonth() === date2.getMonth() &&
		date1.getUTCDate() === date2.getUTCDate()
	);
}

export function CreateDateFromNoticeDate(dateString: string): Date {
	if (!dateString || typeof dateString !== 'string') {
		const now = new Date();
		return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
	}
	const trimmed = dateString.trim();
	if (!trimmed) {
		const now = new Date();
		return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
	}
	if (trimmed.includes("/") && trimmed.includes(", ")) /* Android: "M/D/YYYY, H:mm:ss AM/PM" */ {
		try { return HandleDateFromAndroid(trimmed); } catch { /* formato distinto, sigue con HandleDateFromWeb */ }
	}
	if (trimmed.length === 19 && /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(trimmed)) /* iPhone: "DD-MM-YYYY HH:mm:ss" */ {
		try { return HandleDateFromIphone(trimmed); } catch { /* formato distinto, sigue con HandleDateFromWeb */ }
	}
	/* Cualquier otro formato: YYYY-MM-DD, con/sin hora, ISO, etc. */
	return HandleDateFromWeb(trimmed);
}

/**
 * Parsea fechas en múltiples formatos (origen desconocido):
 * - YYYY-MM-DD (input date, solo fecha)
 * - YYYY-MM-DD HH:mm:ss, YYYY-MM-DD HH:mm:ss.fff
 * - YYYY-MM-DDTHH:mm:ss, YYYY-MM-DDTHH:mm:ss.fffZ (ISO)
 * - DD-MM-YYYY, DD-MM-YYYY HH:mm:ss
 * - DD/MM/YYYY (cuando no coincide con Android "M/D/YYYY, H:mm:ss AM/PM")
 * - Fallback: new Date(str) y, si falla, fecha de hoy a 00:00
 */
export function HandleDateFromWeb(dateAsString: string): Date {
	const parts = dateAsString.split(/\s|T/);
	const datePart = (parts[0] || '').trim();

	// YYYY-MM-DD (con o sin hora)
	if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
		const [year, month, day] = datePart.split('-').map(Number);
		const timePart = parts[1];
		if (!timePart) {
			return new Date(year, month - 1, day, 0, 0, 0);
		}
		const timeClean = (timePart.replace(/Z$/i, '').split('.')[0] || '0:0:0').trim();
		const [h, m, s] = timeClean.split(':').map((n) => Number(n) || 0);
		return new Date(year, month - 1, day, h, m, s);
	}

	// DD-MM-YYYY (con o sin hora)
	if (/^\d{2}-\d{2}-\d{4}$/.test(datePart)) {
		const [day, month, year] = datePart.split('-').map(Number);
		const timePart = parts[1];
		if (!timePart) {
			return new Date(year, month - 1, day, 0, 0, 0);
		}
		const timeClean = (timePart.replace(/Z$/i, '').split('.')[0] || '0:0:0').trim();
		const [h, m, s] = timeClean.split(':').map((n) => Number(n) || 0);
		return new Date(year, month - 1, day, h, m, s);
	}

	// DD/MM/YYYY (con o sin hora; "M/D/YYYY, H:mm:ss AM/PM" ya se envía a Android)
	if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(datePart)) {
		const [day, month, year] = datePart.split('/').map(Number);
		const timePart = parts[1];
		if (!timePart) {
			return new Date(year, month - 1, day, 0, 0, 0);
		}
		const timeClean = (timePart.replace(/Z$/i, '').split('.')[0] || '0:0:0').trim();
		const [h, m, s] = timeClean.split(':').map((n) => Number(n) || 0);
		return new Date(year, month - 1, day, h, m, s);
	}

	// Fallback: Date nativo (ISO 8601, timestamps, etc.)
	const parsed = new Date(dateAsString);
	if (!isNaN(parsed.getTime())) {
		return parsed;
	}

	// Último recurso: hoy a 00:00
	const now = new Date();
	return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
}

export function HandleDateFromAndroid(dateAsString: string) : Date {
	const normalDate = dateAsString.split(", ")[0]
	const [month, day, year] = normalDate.split('/').map(Number);
	const hoursDate = dateAsString.split(", ")[1]
	const cleanHoursDate = hoursDate.replace(/\s+/g, " ");
	const hoursDateSplited = cleanHoursDate.split(" ");
	const [hour, minute, second] = hoursDateSplited[0].split(":").map(Number)
	if (hoursDateSplited[1].includes("PM")) {
		return new Date(year, month - 1, day, hour + 12, minute, second)
	}
	return new Date(year, month - 1, day, hour, minute, second)
}

export function HandleDateFromIphone(dateAsString: string) : Date {
	const normalDate = dateAsString.split(" ")[0]
	const hoursDate = dateAsString.split(" ")[1]
	const [day, month, year] = normalDate.split('-').map(Number);
	const [hour, minute, second] = hoursDate.split(":").map(Number)
	return new Date(year, month - 1, day, hour, minute, second)
}


export function FormatDate(currentDate: Date): string {

	// NOTE: In case of backend date format change, update this code.

	const formattedDate = currentDate.getFullYear() + "-" +
		String(currentDate.getMonth() + 1).padStart(2, '0') + "-" +
		String(currentDate.getDate()).padStart(2, '0') + " " +
		String(currentDate.getHours()).padStart(2, '0') + ":" +
		String(currentDate.getMinutes()).padStart(2, '0') + ":" +
		String(currentDate.getSeconds()).padStart(2, '0') + "." +
		String(currentDate.getMilliseconds()).padStart(3, '0');
	return formattedDate;
}

export function GetDayFromNow(dateChanger: number): string {
	const currentDate = new Date()
	currentDate.setDate(currentDate.getDate() + dateChanger)
	return FormatDate(currentDate)
}